export const ENABLE_ACCOUNT_PENDING = 'ENABLE_ACCOUNT_PENDING';
export const ENABLE_ACCOUNT_ERROR = 'ENABLE_ACCOUNT_ERROR';
export const ENABLE_ACCOUNT_ERROR_CLEAR = 'ENABLE_ACCOUNT_ERROR_CLEAR';
export const ENABLE_ACCOUNT_SUCCESS = 'ENABLE_ACCOUNT_SUCCESS';
